module.exports = __webpack_public_path__ + "img/icon-step.e4e70a8b.svg";